import { useQuery, useReactiveVar } from '@apollo/client';
import { GET_PRICING_TARGETS } from 'graphql/queries/getPricingTargets';
import { useMemo } from 'react';
import { featureCountryCode } from 'states/persistInStorage';
import {
  CountryCode,
  Maybe,
  Query,
  QueryGetPricingTargetsArgs,
} from 'types/generatedSchemaTypes';
import { extractParkingZoneUidsFromPricingTargets } from 'utils/parkUtils';

interface UseLTPParkZonesReturn {
  parkingZonesDataUids: string[];
  loading: boolean;
  error: any;
}

export const useGetParkingZonesWithPrepaidTickets = (
  currentAppCountry: Maybe<CountryCode>,
  enabled: boolean
): UseLTPParkZonesReturn => {
  const countryCode = useReactiveVar(featureCountryCode);

  const { data, loading } = useQuery<Query, QueryGetPricingTargetsArgs>(
    GET_PRICING_TARGETS,
    {
      variables: {
        pricingType: 'SHORT_TERM',
        countryCode: currentAppCountry || 'FI',
        withPredefinedTickets: true,
      },
      skip: !enabled || !countryCode,
      fetchPolicy: 'cache-and-network',
    }
  );

  const parkingZonesDataUids = useMemo(() => {
    if (!data?.getPricingTargets) return [];
    return extractParkingZoneUidsFromPricingTargets(data.getPricingTargets);
  }, [data?.getPricingTargets]);

  return { parkingZonesDataUids, loading, error: null };
};
